import React, { useEffect } from "react";
import { useListManager } from "../../contexts/list.manager";
import Button from "../Button/Button";
import DeleteButton from "../DeleteButton/DeleteButton";
import "./Form.css";
import { useNavigate } from "react-router-dom";

const Form = ({ isSubmitting = false, ...props }) => {
	const { closeForm } = useListManager();
	const navigate = useNavigate();

	const handleClickCancel = (props) => {
		closeForm();
	};

	useEffect(() => {
		if (!props.navigateCancelUrl) return;
		function onKeyUp(event) {
			if (event.key === "Escape") {
				handleClickCancel();
				navigate(props.navigateCancelUrl, { replace: true });
			}
		}
		window.addEventListener("keyup", onKeyUp);
		return () => {
			window.removeEventListener("keyup", onKeyUp);
		};
	}, [props]);

	return (
		<form
			ref={props.formRef}
			onSubmit={props.handleSubmit}
			className={`form-inputs-container ${props.className} ${props.type === 'consulta' ? 'form-consulta' : ''}`}
		>
			{props.type === "consulta" ? (
				<React.Fragment>
					<div className="form-buttons-container">
						{props.deleteButNotSynqed ? (
							<h1 className="already-deleted-message">
								Este registro está desabilitado. Sincronize com o equipamento
								para finalizar o processo de exclusão.
							</h1>
						) : (
							<React.Fragment>
								{props.handleClickEdit && (
									<Button
										className={"button-blue"}
										label={"Editar"}
										action="edit"
										onClick={props.handleClickEdit}
										disabled={isSubmitting}
									/>
								)}
								{props.handleDelete && (
									<DeleteButton
										askForPassword={props.askForPasswordOnDelete}
										handleDelete={props.handleDelete}
										className={"button-white"}
										disabled={isSubmitting}
									/>
								)}
								{props.aditionalButton && (
									<div style={{ marginLeft: "10px" }}>
										{props.aditionalButton}
									</div>
								)}
							</React.Fragment>
						)}
					</div>
					<div className="form-inputs-wrap" style={{ maxWidth: "550px" }}>
						{props.children}
					</div>
				</React.Fragment>
			) : (
				<React.Fragment>
					<div className="form-inputs-wrap">{props.children}</div>
					{!props.hideSaveButtons && (
						<div className="form-buttons-container">
							{props.aditionalButtonCadastro && (
								<div style={{ marginRight: "10px" }}>
									{props.aditionalButtonCadastro}
								</div>
							)}
							<div className="form-buttons">
								{!props.hideCancelButton && (
									<Button
										className={"button-white"}
										label={"Cancelar"}
										navigate={props.navigateCancelUrl}
										onClick={props.handleClickCancel ?? handleClickCancel}
										disabled={isSubmitting}
									/>
								)}
								<Button
									className={"button-blue"}
									disabled={isSubmitting ?? props.saveDisabled}
									label={props.saveButtonText ?? "Salvar"}
									type={"submit"}
									isLoading={isSubmitting}
								/>
							</div>
						</div>
					)}
				</React.Fragment>
			)}
		</form>
	);
};

export default Form;
